import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { toastFamily, toastInfo } from '../recoil';
import { v4 as uuidv4 } from 'uuid';

const useToast = () => {
  const [queue, setQueue] = useRecoilState(toastInfo);
  const [toast, setToast] = useRecoilState(toastFamily(queue[0]?.id));

  const addToast = (message: string | {}) => {
    pushQueue({ id: uuidv4(), message });
  };

  const pushQueue = (info: any) => {
    setQueue((prev: any) => {
      const newArr = [...prev];
      newArr.push(info);
      return newArr;
    });
  };

  const popQueue = () => {
    setQueue((prev: any) => {
      const newArr = [...prev];
      newArr.shift();
      return newArr;
    });
  };

  const closeToast = () => {
    setToast((cur: any) => ({ ...cur, open: false }));
    setTimeout(() => {
      popQueue();
    }, 500);
  };

  useEffect(() => {
    if (queue.length) {
      setToast((cur: any) => ({
        ...cur,
        key: queue[0].id,
        open: true,
        message: queue[0].message,
        onClose: closeToast,
      }));
    }
  }, [queue]);

  return {
    addToast,
    toast,
  };
};

export default useToast;
